import styled from 'styled-components';
import { constants } from '../constants';
import { SYS_PAGE_MARGIN, SYS_SPACE_RELATIVE_XL } from '@oneaudi/unified-web-common';

const device = {
  desktop: `(min-width:${constants.displaySizes.desktop})`,
  largeDesktop: `(min-width:${constants.displaySizes.largeDesktop})`,
  smallDesktop: `(min-width:${constants.displaySizes.smallDesktop})`,
  mobile: `(max-width:${constants.displaySizes.mobile})`,
  tablet: `(min-width: ${constants.displaySizes.tablet})`,
  smallTablet: `(max-width: ${constants.displaySizes.tablet})`,
};

interface ContainerProps {
  // eslint-disable-next-line
  variant: any;
  standAlonePBC?: boolean;
  removePadding: boolean;
}

export const Container = styled.div<ContainerProps>`
  grid-template-columns: auto;
  padding: ${(props) =>
    props.standAlonePBC && !props.removePadding
      ? `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN}`
      : '0px'};
  position: relative;

  @media ${device.smallTablet} {
    column-gap: 17px;
    grid-template-columns: auto auto;
    padding: ${(props) =>
      props.standAlonePBC && !props.removePadding
        ? `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN}`
        : '0px'};
  }
  @media ${device.mobile} {
    padding: ${(props) =>
      props.standAlonePBC && !props.removePadding
        ? `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN}`
        : '0px'};
  }
  @media ${device.tablet} {
    column-gap: 17px;
    grid-template-columns: auto auto;
    padding: ${(props) =>
      props.standAlonePBC && !props.removePadding
        ? `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN}`
        : '0px'};
  }
  @media ${device.smallDesktop} {
    column-gap: 48px;
    padding: ${(props) =>
      props.standAlonePBC && !props.removePadding
        ? `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN}`
        : '0px'};
  }
  @media ${device.desktop} {
    column-gap: 97px;
    padding: ${(props) =>
      props.standAlonePBC && !props.removePadding
        ? `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN}`
        : '0px'};
  }
  @media ${device.largeDesktop} {
    column-gap: 60px;
    padding: ${(props) =>
      props.standAlonePBC && !props.removePadding
        ? `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN}`
        : '0px'};
    max-width: 1728px;
    width: 100%;
  }
`;
